import React, { useEffect, useState } from 'react';
import { Card, Stack, Button, Container, Typography, Box, CircularProgress, Modal, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DataGrid, GridToolbar, GridToolbarContainer } from '@mui/x-data-grid';
import { DeleteOutline } from '@mui/icons-material';
import EditIcon from '@mui/icons-material/Edit';
import Iconify from '../../components/iconify';
import AddLoan from './Add';
import { apiget, deleteManyApi } from '../../service/api';
import DeleteModel from '../../components/Deletemodle';
import TableStyle from '../../components/TableStyle';
import EditModel from './Edit';

function CustomToolbar({ selectedRowIds, fetchdata, view, setView }) {
  const [opendelete, setOpendelete] = useState(false);
  const [userAction, setUserAction] = useState(null);

  const handleCloseDelete = () => setOpendelete(false);

  const handleOpenDelete = () => setOpendelete(true);

  const deleteManyLoan = async (data) => {
    const result = await deleteManyApi('loan/deletemany', data);
    fetchdata();
    setUserAction(result);
    handleCloseDelete();
  };

  useEffect(() => {
    setUserAction(userAction);
  }, [userAction]);

  return (
    
    <GridToolbarContainer>
        <FormControl variant="outlined" size="small" sx={{ minWidth: 120, marginRight: 2 }}>
          <InputLabel>View</InputLabel>
          <Select
            value={view}
            onChange={(e) => setView(e.target.value)}
            label="View"
          >
            <MenuItem value="pipeline">Pipeline</MenuItem>
            <MenuItem value="prospects">Prospects</MenuItem>
          </Select>
        </FormControl>
      <GridToolbar />
      <Box display="flex" justifyContent="flex-end" width="100%">
      
        {selectedRowIds && selectedRowIds.length > 0 && (
          <Button variant="text" sx={{ textTransform: 'capitalize' }} startIcon={<DeleteOutline />} onClick={handleOpenDelete}>
            Delete
          </Button>
        )}
      </Box>
      <DeleteModel opendelete={opendelete} handleClosedelete={handleCloseDelete} deletedata={deleteManyLoan} id={selectedRowIds} />
    </GridToolbarContainer>
  );
}

const Loan = () => {
  const [userAction, setUserAction] = useState(null);
  const [selectedRowIds, setSelectedRowIds] = useState([]);
  const [loanData, setLoanData] = useState([]);
  const [id, setId] = useState('');
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState('pipeline'); // Add state for the dropdown
  const navigate = useNavigate();

  const userid = localStorage.getItem('user_id');
  const userRole = localStorage.getItem('userRole');

  // open edit model
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  const handleOpenAdd = () => setOpenAdd(true);
  const handleCloseAdd = () => setOpenAdd(false);

  const columns = [
    {
      field: 'Loan.BorrowerName',
      headerName: 'Borrower Name',
      flex: 1,
      cellClassName: 'name-column--cell name-column--cell--capitalize',
      renderCell: (params) => {
        const handleFirstNameClick = () => {
          navigate(`/dashboard/loan/view/${params.row.loanId}`);
        };

        return <Box onClick={handleFirstNameClick}>{params.value}</Box>;
      }
    },
    {
      field: 'Fields.1240',
      headerName: 'Email',
      flex: 1,
      cellClassName: 'name-column--cell--capitalize'
    },
    {
      field: 'Loan.LoanNumber',
      headerName: 'Loan Number',
      flex: 1
    },
    {
      field: 'Loan.LoanRate',
      headerName: 'Interest Rate',
      flex: 1
    },
    {
      field: 'Loan.LoanAmount',
      headerName: 'Loan Amount',
      flex: 1
    },
    {
      field: 'Loan.LoanPurpose',
      headerName: 'Loan Purpose',
      flex: 1
    },
    {
      field: 'Loan.LastModified',
      headerName: 'Last Modified',
      flex: 1
    },
    {
      field: 'action',
      headerName: 'Action',
      flex: 1,
      renderCell: (params) => {
        const handleEditClick = async (data) => {
          setId(data);
          handleOpenEdit();
        };
        return (
          <>
            <EditModel open={openEdit} handleClose={handleCloseEdit} id={id} fetchLoan={fetchdata} />
            <Button variant="text" size="small" color="primary" onClick={() => handleEditClick(params?.row?.loanId)}>
              <EditIcon />
            </Button>
          </>
        );
      }
    }
  ];

  const fetchdata = async () => {
    try {
      console.log('Fetching loan data...');
      setLoading(true);
      const result = await apiget(`loan/list`);
      console.log('API call result:', result);

      if (result && result.status === 200) {
        console.log('Data fetched successfully:', result.data.result);

        // Transform the fetched data to the required format
        const formattedData = result.data.result.map((loan) => ({
          loanId: loan.loanId,
          'Loan.LoanPurpose': loan.fields['Loan.LoanPurpose'] || null,
          'Fields.1240': loan.fields['Fields.1240'] || null,
          'Loan.LoanNumber': loan.fields['Loan.LoanNumber'] || null,
          'Loan.LoanRate': loan.fields['Loan.LoanRate'] || null,
          'Loan.LoanAmount': loan.fields['Loan.LoanAmount'] || null,
          'Loan.BorrowerName': loan.fields['Loan.BorrowerName'] || null,
          'Loan.LastModified': loan.fields['Loan.LastModified'] || null
        }));

        setLoanData(formattedData);
      } else {
        console.log('Unexpected status code:', result);
      }
    } catch (error) {
      console.error('Error fetching loan data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectionChange = (selectionModel) => {
    setSelectedRowIds(selectionModel);
  };

  useEffect(() => {
    fetchdata();
  }, [openAdd, userAction]);

  return (
    <>
      <AddLoan open={openAdd} handleClose={handleCloseAdd} setUserAction={setUserAction} />

      <Container>
        <Stack direction="row" alignItems="center" mb={5} justifyContent={"space-between"}>
          <Typography variant="h4">Loan</Typography>
          <Stack direction="row" alignItems="center" justifyContent={"flex-end"} spacing={2}>
            <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />} onClick={handleOpenAdd}>
              New Loan
            </Button>
          </Stack>
        </Stack>
        <TableStyle>
          <Box width="100%">
            <Card style={{ height: '600px', paddingTop: '15px' }}>
              <DataGrid
                rows={loanData}
                columns={columns}
                components={{ Toolbar: () => CustomToolbar({ selectedRowIds, fetchdata, view, setView }) }}
                checkboxSelection
                onRowSelectionModelChange={handleSelectionChange}
                rowSelectionModel={selectedRowIds}
                getRowId={(row) => row.loanId}
              />
            </Card>
          </Box>
        </TableStyle>
      </Container>

      <Modal
        open={loading}
        aria-labelledby="loading-modal-title"
        aria-describedby="loading-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 300,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
          <CircularProgress />
          <Typography variant="body2" sx={{ mt: 2 }}>
            Loading Loans...
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default Loan;
